import React, { Component } from 'react'
import ReactDOM from "react-dom";
import {
    DKInputForm,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    isEmpty,
    DKSpinner,
    DKIcons,
    DKButton
} from "deskera-ui-library";
import i18next from 'i18next';

import { COLUMN_CODE, TableManger, TABLES } from '../managers/TableManger';
import DataGridUtility from '../utility/DataGridUtility';
import { biWeeklyPayDays, COUNTRY_CODE, INPUT_TYPE, payDayMonthly, payDayTwicePerMonthDays, payPeriod, PROFILE_STAGES_CONSTANT, workWeek } from '../constants/Constant';
import { PayrollManager } from '../managers/PayrollManager';
import Popup from '../components/common/Popup';
import { fetchPayschedules, fetchUsers } from '../Redux/Slices/PayrollSlice';
import PayScheduleService from '../services/PayScheduleService';
import moment from 'moment';
import ProfileSetupService from '../services/ProfileSetup-service';
import TenantManager from '../managers/TenantManager';
import { TENANT, TenantService } from '../managers/TenantManagerService';
import { PayScheduleManager } from '../managers/PayScheduleManager';
import PayrollService from '../services/PayrollService';
import Utility, { deepClone } from '../utility/Utility';

export interface IAddNewRecordPopUpProps {
    tableName: string;
    recordId?: string;
    id: string;
    onSave?: (data: any) => void;
    onClose?: () => void;
    defaultValues: any;
    displayName: string;
    isCustomForm: boolean;
    inputData: any;
}


export interface ADD_PAY_SCHEDULE_DATA_TO_SAVE {
    employees: [],
    firstPayDate: string,
    isForAllUsers: boolean,
    name: string,
    payDay: string,
    payPeriod: string,
    workPeriod: {
        from: string,
        to: string
    },
    workWeek: []
    _id?:string,
    location: number,
    customFields: any[]
}

export interface IAddNewRecordPopUpState {
    formFields: any[];
}

class AddEditPaySchedule extends Component<
IAddNewRecordPopUpProps,
IAddNewRecordPopUpState
> {
    columns = [];
    isUpdated: boolean = false;
    defaultValues: any[] = [];
    paySchedules : any[] = [];
    usersList : any[] = [];
    tenantData : any = {};
    isValueUpdated = true;
    isValuedChanged = false;
    defaultOldValues = [];
    customFields = [];
    trackLocation = false
    locationList: any[] = [];
    constructor(props){
        super(props);
        this.state = {
            formFields: []
        }
        this.defaultValues = this.props.defaultValues;
        this.isUpdated = !isEmpty(this.props.recordId);
        this.usersList = this.props.inputData.users || [];
        this.tenantData = TenantManager.getTenantDetails();
        this.defaultOldValues = deepClone(this.props.defaultValues);
        this.customFields = this.props.inputData?.customFields?.customFields || [];
        if(Utility.isEmpty(this.usersList)) {
            this.getUsers()
        } else {
            this.updateSelectedUser()
        }
        const tenantDetails = TenantManager.getTenantDetails()
        const additionalSettings = tenantDetails
        ? tenantDetails.additionalSettings
        : "";
        const locationSettings = additionalSettings ? additionalSettings?.['LOCATION'] : {};
        this.trackLocation = locationSettings?.trackLocation || false;

        if(this.trackLocation && this.props.inputData.locationList){
            const locations = this.props.inputData.locationList.map((x) => {
                return {
                    id : x.id,
                    name: x.label,
                };
            });
            this.locationList = locations ? locations : []
        }
    }

    componentDidMount() {
        this.buildForm(true);
    }
    
    getUsers() {
        showLoader()
        PayrollService.getUsersList().then((res:any)=>{
            removeLoader()
            if(res && res.users) {
                let employeeId = this.defaultOldValues[TableManger.getColumnId(
                    TABLES.ADD_PAY_SCHEDULE,
                    COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES
                  )];
                if(!Utility.isEmpty(this.defaultOldValues) && employeeId) {
                    employeeId = employeeId.filter(e=> res.users?.findIndex(u=>u.userId==e) !=-1)
                    employeeId = employeeId.map(emp=>{
                        return res.users.findIndex(user=> 
                            user.userId==emp
                            
                        )
                    })
                }
                this.defaultValues[TableManger.getColumnId(
                    TABLES.ADD_PAY_SCHEDULE,
                    COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES
                  )] = employeeId;
                this.usersList = res.users;
                this.setState({
                    ...this.state
                })
                this.buildForm(false);
            }
        });
    }
    updateSelectedUser() {
        let employeeId = this.defaultOldValues[TableManger.getColumnId(
            TABLES.ADD_PAY_SCHEDULE,
            COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES
          )];
        if(!Utility.isEmpty(this.defaultOldValues) && employeeId) {
            employeeId = employeeId.filter(e=> this.usersList?.findIndex(u=>u.userId==e) !=-1)
        }
        this.defaultValues[TableManger.getColumnId(
            TABLES.ADD_PAY_SCHEDULE,
            COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES
          )] = employeeId;
    }
    getUsersByLocation(location) {
        showLoader()
        PayrollService.getUsersByLocation(location).then((res:any)=>{
            removeLoader()
            if(res && res.users) {
                let employeeId = this.defaultOldValues[TableManger.getColumnId(
                    TABLES.ADD_PAYROLL,
                    COLUMN_CODE.ADD_PAYROLL.USERS
                  )];
                if(!Utility.isEmpty(this.defaultOldValues) && employeeId) {
                    employeeId = employeeId.filter(e=> res.users?.findIndex(u=>u.userId==e) !=-1)
                    employeeId = employeeId.map(emp=>{
                        return res.users.findIndex(user=> 
                            user.userId==emp
                            
                        )
                    })
                }
                this.defaultValues[TableManger.getColumnId(
                    TABLES.ADD_PAYROLL,
                    COLUMN_CODE.ADD_PAYROLL.USERS
                  )] = employeeId;
                this.usersList = res.users;
                this.setState({
                    ...this.state
                })
                this.buildForm(false);
            }
        });
    }
    buildForm = (params) => {
        this.columns = this.updateColumnConfig(params);

        this.putAdditionalFields().then(() => {
            let formFields = DataGridUtility.getFormElements(
                this.columns,
                this.defaultValues
            );
            this.setState({
                formFields,
            });
        });
    }

    updateColumnConfig = (params) => {
        let columnConfig = [];
        columnConfig = params ? JSON.parse(JSON.stringify(TableManger.getTableColumns("people_add_pay_schedule").filter(
            (obj) => obj.editable && obj.uiVisible
        ))) : this.columns.filter(
            (obj) => obj.editable && obj.uiVisible
        )
        columnConfig = this.updateColumnConfigWithLocationFields(columnConfig);
        columnConfig = this.updateColumnConfigWithCustomField(columnConfig);
        return columnConfig;
    }

    putAdditionalFields = () => {
        switch (this.props.tableName) {
            case TABLES.ADD_PAY_SCHEDULE:
                this.updateFormOptions();
                return Promise.resolve();
            default:
                return Promise.resolve();
        }
    };

    updateFormOptions() {
        let countryCode = TenantService.get(TENANT.COUNTRY_CODE)
        this.columns.forEach(column => {
            switch (column.columnCode) {
                case COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_DAY:
                    let columnCode = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_PERIOD)
                    let workWeekColumnCode = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_WEEK)
                    // column["options"] = payDayMonthly;
                    let payPeriodType = this.props.defaultValues[columnCode][0]
                    switch(payPeriodType) {
                        case "monthly":
                        case 0:
                            column["options"] = payDayMonthly;
                            break;
                        case "weekly":
                        case 1:
                            let selectedWorkWeek = this.defaultValues[workWeekColumnCode]
                            let options = []
                            
                            workWeek.forEach((w,ind)=>{
                                let i = selectedWorkWeek.findIndex(res=>w.id==res)
                                if(ind == 0 || i!=-1) {
                                    options.push(w)
                                }
                            })
                            column["options"] = options
                            break;
                        case "twicePerMonth":
                        case 2:
                            column["options"] = payDayTwicePerMonthDays
                            break;
                        case "biWeekly":
                        case 3:
                            let biWeeklyPayDaysList = []
                            let selectedWeek = this.defaultValues[workWeekColumnCode]
                            
                            selectedWeek.forEach((workDay,ind)=>{
                                if(workDay){
                                    biWeeklyPayDays.forEach((day, i) => {
                                    if ((workDay) === (i) || (workDay+7) === i) {
                                        biWeeklyPayDaysList.push(day);
                                    }
                                    });
                                }
                            })
                             
                            column["options"] = biWeeklyPayDaysList;
                            break;
                        default:
                            column["options"] = payDayMonthly;
                            break;
                    }
                    
                    break;
                case COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES:
                    const processedData = PayrollManager.parseUserList(this.usersList);
                    column["options"] = processedData;
                    break;
                case COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_PERIOD:
                    let payPeriodOptions = []
                    switch(countryCode) {
                        case COUNTRY_CODE.INDIA:
                            payPeriodOptions = payPeriod.filter(res=>{
                                if(res.id == 'monthly') {
                                    return res
                                }
                            })
                            break;
                        case COUNTRY_CODE.US:
                            payPeriodOptions = payPeriod;
                            break;
                        default:
                            payPeriodOptions = payPeriod;
                            break;
                    }
                    column["options"] = payPeriodOptions
                    break;
                case COLUMN_CODE.PAY_SCHEDULE_LIST.LOCATION:
                    const { isLocationActive, locationLabel } = this.getLocationValueAndLabel();
                    const locations = PayrollManager.parseLocationList(this.locationList);
                    column["options"] = locations;
                    column["name"] = locationLabel;
                    break;
            }
        });

        if(this.isUpdated && this.isValueUpdated) {
            this.isValueUpdated = false;
            PayrollManager.getDataToUpdateForPayroll(this.defaultValues, this.columns);
        }
        let isApplicable = this.defaultValues[TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.IS_APPLICABLE_TO_ALL)];
        this.updateFormFieldColumns(isApplicable[0]);
    }

    updateFormFieldColumns(isApplicable) {
        if (isApplicable === 0 || isApplicable === undefined) {
            this.columns = this.columns.filter(element => element.columnCode != COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES)
            this.columns.forEach(element => {
                if (element.columnCode === COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES) {
                    element['uiVisible'] = false;
                    element['hidden'] = true;
                    element['required'] = false;
                }

            });
        } else {
            let columnToAdd = TableManger.getTableColumns("people_add_pay_schedule").filter(x => x.columnCode === COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES);
            if (columnToAdd && columnToAdd.length > 0) {
                let isPresent = this.columns.some(x => x.columnCode === columnToAdd[0].columnCode);
                const processedData = PayrollManager.parseUserList(this.usersList);
                if (isPresent) {
                    this.columns.forEach(element => {
                        if (element.columnCode === COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES) {
                            element['uiVisible'] = true;
                            element['hidden'] = false;
                            element['required'] = true;
                            element["options"] = processedData;
                        }

                    });
                } else {
                    columnToAdd[0]['uiVisible'] = true;
                    columnToAdd[0]['hidden'] = false;
                    columnToAdd[0]['required'] = true;
                    columnToAdd[0]["options"] = processedData;
                    this.columns.push(columnToAdd[0]);
                }
            }
        }
    }

    onChange = (allFields, changedData) => {
        this.isValuedChanged = true
        switch (changedData.columnCode) {
            case COLUMN_CODE.PAY_SCHEDULE_LIST.IS_APPLICABLE_TO_ALL:
                this.defaultValues[changedData.id] = changedData.value;
                if (changedData && changedData.value && changedData.value.length > 0 && changedData.value[0] === 0) {
                    this.columns.forEach(element => {
                        if (element.columnCode === COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES) {
                            element['uiVisible'] = false;
                            element['hidden'] = true;
                            element['required'] = false;
                        }

                    });
                } else if (changedData && changedData.value && changedData.value.length > 0 && changedData.value[0] === 1) {
                    let {isFieldPresent, fieldIndex} = this.checkIfColumnAlreadyExist(COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES, this.columns);
                    let columnToAdd = TableManger.getTableColumns("people_add_pay_schedule").filter( x=> x.columnCode === COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES);
                    if(!isFieldPresent && columnToAdd && columnToAdd.length > 0) {
                        columnToAdd[0]['uiVisible'] = true;
                        columnToAdd[0]['hidden'] = false;
                        columnToAdd[0]['required'] = true;
                        this.columns.push(columnToAdd[0]);
                    } else if(isFieldPresent && fieldIndex != -1) {
                        this.columns[fieldIndex]['uiVisible'] = true;
                        this.columns[fieldIndex]['hidden'] = false;
                        this.columns[fieldIndex]['required'] = true;
                    }
                }
                 else {
                    this.columns.forEach(element => {
                        if (element.columnCode === COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES) {
                            element['uiVisible'] = false;
                            element['hidden'] = true;
                            element['required'] = false;
                        }

                    });
                }
                break;
            case COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_PERIOD:
                this.defaultValues[changedData.id] = changedData.value;
                if (changedData.value.length != 0) {
                    this.updateFirstPayDate(changedData.value[0],'0',changedData)
                }
                
                break;
            case COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_DAY:
                this.defaultValues[changedData.id] = changedData.value;
                let payeriodColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_PERIOD);
                let selectedPayPeriod = this.defaultValues[payeriodColumnId]
                
                
                if (changedData.value.length != 0) {
                    this.updateFirstPayDate(selectedPayPeriod[0],changedData.value[0],changedData)
                }
                break;
            case COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_WEEK:
                this.defaultValues[changedData.id] = changedData.value;
                if(PayScheduleManager.workWeekDaysValid(changedData.value) ) {
                    showToast(i18next.t("COMPANY_WORK_WEEK_LIMIT"), TOAST_TYPE.FAILURE);
                }
                break;
            case COLUMN_CODE.PAY_SCHEDULE_LIST.LOCATION:
                this.defaultValues[changedData.id] = changedData.value;
                if (changedData && changedData.value.length === 1) {
                    const locName = changedData.options[changedData.value[0]]
                    const locObj = this.locationList.find(list => list.name === locName)
                    if (locObj && locObj.id) {
                        this.getUsersByLocation(locObj.id);
                    } else {
                        this.getUsers()
                    }

                    const usersColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES);
                    this.defaultValues[usersColumnId] = [];
                    this.defaultOldValues[usersColumnId] = [];
                }
                this.buildForm(false);
                break;
            default:
                this.checkValidationIfAny(changedData);

        }
        this.buildForm(false);
    }

    checkValidationIfAny = (changedData) => {
        const validation = changedData.validation || [];
        if(!Utility.isEmpty(validation.length)) {
            validation.forEach(v => {
                for (const k in v) {
                    switch(k) {
                        case "maxLength":
                            const maxLength = parseInt(v[k]);
                            if(typeof changedData.value === "string" && changedData.value.length <= maxLength) {
                                this.defaultValues[changedData.id] = changedData.value;
                            } else {
                                showToast(`Input length cannot be greater than ${maxLength}`, TOAST_TYPE.FAILURE);
                            }
                            break;
                        case "decimalPrecision":
                            const decimalPrecision = parseInt(v[k]);
                            const valueArray = changedData.value.split(".");
                            if(valueArray.length > 1) {
                                const precisionValue =  valueArray[1];
                                if(precisionValue.length <= decimalPrecision) {
                                    this.defaultValues[changedData.id] = changedData.value;
                                } else {
                                    showToast(`Length after decimal cannot be greater than ${decimalPrecision}`, TOAST_TYPE.FAILURE);
                                }
                            } else {
                                this.defaultValues[changedData.id] = changedData.value;
                            }

                            break;
                        default:
                            this.defaultValues[changedData.id] = changedData.value;
                    }
                }
                
            });
        } else {
            this.defaultValues[changedData.id] = changedData.value;
        }
    }

    updateFirstPayDate(payPeriodInd,selectedPayDay,changedData) {

        let payDayColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_DAY);
        let payDateColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_DATE);
        let payeriodColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_PERIOD);
        this.defaultValues[payDayColumnId] = [selectedPayDay]
        let workWeekColumnCode = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_WEEK)
        // if (changedData.value.length != 0) {
            let firstPayDay = new Date()
            switch (payPeriodInd) {
                case 0:// monthly
                    
                    if (selectedPayDay.toString() === '0') {
                        this.defaultValues[payDateColumnId] = moment().endOf('month').toDate();
                    } else {
                        firstPayDay = new Date(firstPayDay.getFullYear(), firstPayDay.getMonth(), parseInt(selectedPayDay));
                        this.defaultValues[payDateColumnId] = firstPayDay
                    }
                    break;
                case 1:// weekly
                    let selectedWeek = this.defaultValues[workWeekColumnCode];
                    if (selectedPayDay.toString() === '0') {
                        firstPayDay = new Date(firstPayDay.getFullYear(), firstPayDay.getMonth(), firstPayDay.getDate() + (firstPayDay.getDay() === 0 ? 0 : this.getTheLastWorkingDay(selectedWeek)) - firstPayDay.getDay());

                    } else {
                        firstPayDay = new Date(firstPayDay.getFullYear(), firstPayDay.getMonth(), firstPayDay.getDate() + (firstPayDay.getDay() === 0 ? 0 : parseInt(selectedPayDay)) - firstPayDay.getDay());
                    }
                    this.defaultValues[payDateColumnId] = firstPayDay
                    break;
                case 2: //15 twise per month
                    if (this.defaultValues[payDayColumnId] && this.defaultValues[payDayColumnId].length != 0 && this.defaultValues[payDayColumnId][0] == '0') {
                        firstPayDay = new Date(firstPayDay.getFullYear(), firstPayDay.getMonth(), 15);
                        // } else {
                        // firstPayDay = new Date(firstPayDay.getFullYear(), firstPayDay.getMonth(), parseInt(this.payDayTwicePerMonth.firstPayDay));
                    }
                    this.defaultValues[payDateColumnId] = firstPayDay
                    break;

                case 3: // bi-weekly
                let payDay = this.columns.filter(col=>col.columnCode == 'payDay')
                if(payDay && payDay[0]) {
                    let opt = payDay[0].options[selectedPayDay];
                    selectedPayDay = (opt.id == 'lastWorkingDayWeek' || opt.id =='lastWorkingDayMonth') ? 1 : opt.id
                } else {
                    selectedPayDay = ((parseInt(selectedPayDay) % 2 ) == 0) ? selectedPayDay : selectedPayDay+7
                }
                
                if(parseInt(selectedPayDay)>6)
                {
                    firstPayDay.setDate(firstPayDay.getDate() + (7 + parseInt(selectedPayDay) - firstPayDay.getDay()));
                }
                else{
                    firstPayDay.setDate(firstPayDay.getDate() + (7 + parseInt(selectedPayDay) - firstPayDay.getDay()) % 7);
                }
                
                    this.defaultValues[payDateColumnId] = firstPayDay
                    break;
            }
        // }
    }
    calFirstPayDate(payDate){
        
    }
    getTheLastWorkingDay(selectedWorkDays) {
        for (let i = selectedWorkDays.length - 1; i >= 0; i--) {
            if (selectedWorkDays[i]) {
                return selectedWorkDays[i];
            }
        }
    }

    removePopUp = () => {
        ReactDOM.unmountComponentAtNode(document.getElementById(this.props.id));
        document.getElementById(this.props.id)?.remove();
    }
    onClose = () => {
        if (this.props.onClose) this.props.onClose();
        this.removePopUp();
    };

    onSave = (data) => {
        this.isValuedChanged = true
        if (this.isValuedChanged){
            switch(this.props.tableName) {
                case TABLES.ADD_PAY_SCHEDULE:
                    this.addDataToPaySchedule(data);
            }
        } else{
            this.onClose()
        }
    };

    addDataToPaySchedule(data) {

        let workPeriodFromColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_PERIOD_FROM);
        let workPeriodToColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_PERIOD_TO);
        let workWeekColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_WEEK);
        
        if(PayScheduleManager.workWeekDaysValid(data[workWeekColumnId])) {
            showToast(i18next.t("COMPANY_WORK_WEEK_LIMIT"), TOAST_TYPE.FAILURE);
            return
        }
        if(data[workPeriodFromColumnId].getTime() > data[workPeriodToColumnId].getTime()) {
            showToast("Please ensure that the Work Period To Date is greater than the Work Period From Date.", TOAST_TYPE.FAILURE);
            return
        }

        let payScheduleColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_SCHEDULE);
        let payPeriodColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_PERIOD);
        let payDayColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_DAY);
        let payDateColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_DATE);
        let applicableToColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.IS_APPLICABLE_TO_ALL);
        let usersColumnId = TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE,COLUMN_CODE.PAY_SCHEDULE_LIST.EMPLOYEES);
        let isApplicableToAll = data[applicableToColumnId] ? this.isApplicableToAll(data[applicableToColumnId][0]) : true;
        const customFieldsValues = this.getCustomFieldsData(data);
        let paramters: ADD_PAY_SCHEDULE_DATA_TO_SAVE = {
            employees: data[usersColumnId] || [],
            firstPayDate:moment(data[payDateColumnId]).format(),
            isForAllUsers: isApplicableToAll,
            name: data[payScheduleColumnId],
            payDay: data[payDayColumnId] ? data[payDayColumnId][0] : "",
            payPeriod: data[payPeriodColumnId] ? data[payPeriodColumnId][0] : "",
            workPeriod: {
                from: moment(data[workPeriodFromColumnId]).format("DD/MM/YYYY"),
                to: moment(data[workPeriodToColumnId]).format("DD/MM/YYYY")
            },
            workWeek: data[workWeekColumnId],
            location: data['locations'] && data['locations'][0] ? data['locations'][0] : "",
            customFields: customFieldsValues
        }
        if(this.isUpdated) {
            paramters._id = this.props.recordId
        }
        
        showLoader(`Pay schedule is being ${this.isUpdated ? "updated" : "added"}...`);
        (this.isUpdated
            ? PayScheduleService.updatePaySchedule(paramters)
            : PayScheduleService.addPaySchedule(paramters)
        ).finally(() => removeLoader())
            .then(
                (res) => {
                    showToast(
                        `${this.isUpdated ? "Pay schedule Updated" : "Pay schedule Added"} Successfully`,
                        TOAST_TYPE.SUCCESS
                    );
                    this.loadPaySchedule({})
                    this.removePopUp();
                    ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.PAY_SCHEDULE)
                    .then(res=>{
                        TenantManager.setProfileData(res['profileStages']);                    
                    })
                },
                (err) => {
                    if(err?.trim() === "no user found for selected location") {
                        showToast(
                            "No user found for selected location.",
                            TOAST_TYPE.FAILURE
                        );
                    }else{
                        showToast(
                            "Some unknown error occurred at server. Please try after some time.",
                            TOAST_TYPE.FAILURE
                        );
                    }
                }
            );
    }

    getCustomFieldsData = (data) => {
        const customFieldsData = [];
        this.customFields.forEach((c) => {
            if(!Utility.isEmpty(data[c.id])) {
                let group = {
                    fieldId: c.id,
                    fieldName: c.name,
                    fieldValue: this.getCustomFieldInputValue(data[c.id])
                };
                customFieldsData.push(group);
            }
        });
        return customFieldsData;
    }

    getCustomFieldInputValue = (value) => {
        let selectedValue = [];
        if(Array.isArray(value)) {
            selectedValue = value;
        } else {
            selectedValue.push(value);
        }
        return selectedValue;
    }

    loadPaySchedule= async (config) => {
        try {
            PayScheduleService.config = config;
            await this.props.inputData.payScheduleDispatch(fetchPayschedules());
        } catch (err) {
            console.error('Error loading pay schedule: ', err);
        }
    }

    isApplicableToAll(input) {
        let isApplicable = false;
        if (input === "YES") {
            isApplicable = true;
        }
        return isApplicable;
    }

    formatDate(inputDate) {
        let formattedDate = "";
        formattedDate = moment(inputDate).format()
        return formattedDate;
    }

    updateColumnConfigWithLocationFields = (columnConfig) => {
        const { isLocationActive, locationLabel } = this.getLocationValueAndLabel();
        if (isLocationActive) {
            const location = {
                id: 'locations',
                name: locationLabel,
                columnCode: 'locations',
                key: 'locations',
                uiVisible: true,
                required: false,
                type: "select",
                options: PayrollManager.parseLocationList(this.locationList)
            };

            const index = columnConfig.findIndex((c) => c.columnCode === "isForAllUsers");
            if (index !== -1) {
                columnConfig.splice(index, 0, location);
            } else {
                columnConfig.push(location);
            }
        }

        return columnConfig
    }

    getLocationValueAndLabel = () => {
        const tenantDetails = TenantManager.getTenantDetails();
        let isLocationActive = false;
        let locationLabel = "";
        const additionalSettings = tenantDetails
          ? tenantDetails.additionalSettings
          : "";
        const locationSettings = additionalSettings
          ? additionalSettings?.["LOCATION"]
          : {};
        isLocationActive = locationSettings?.trackLocation || false;
        locationLabel = isLocationActive
          ? locationSettings?.locationLabel
          : "";
    
        return { isLocationActive, locationLabel };
    }

    updateColumnConfigWithCustomField = (columnConfig) => {
        this.customFields.forEach((c) => {
            let group = {};
            group['id'] = c.id;
            group['name'] = c.name;
            group['columnCode'] = c.id;
            group['key'] = c.id;
            group['uiVisible'] = true;
            group['required'] = false;
            group = this.getFieldConfigOnType(group, c);
            columnConfig.push(group);
        });
        return columnConfig;
    }

    getFieldConfigOnType = (group, c) => {
        switch(c.type) {
            case "text":
                group['type'] = INPUT_TYPE.TEXT;
                group['validation'] = [{maxLength:c.maxLength}];
                break;
            case "number":
                group['type'] = INPUT_TYPE.NUMBER;
                group['validation'] = [{decimalPrecision:c.decimalPrecision}];
                break;
            case "multiselect":
                const options = c.possibleValues.map((p) => {
                    return{
                        id:p,
                        name:p
                    }
                });
                group['type'] = INPUT_TYPE.MULTI_SELECT;
                group['options'] = options;
                break;
            case "date":
                group['type'] = INPUT_TYPE.DATE;
                break;    
            default:
                group['type'] = INPUT_TYPE.TEXT;
        }
        return group;
    }

    checkIfColumnAlreadyExist = (columnCode, columns) => {
        let isFieldPresent = false;
        let fieldIndex = -1;
        fieldIndex = columns?.findIndex((c) => c.columnCode === columnCode);
        if( fieldIndex != -1) {
            isFieldPresent = true;
        }
        return {isFieldPresent, fieldIndex}
    }


    render() {
        
        return (
            <Popup>
                {this.state.formFields.length !== 0 && (
                    <>
                        <DKInputForm
                            title={`${this.isUpdated ? "Edit" : "Add"} ${this.props.displayName}`}
                            fields={this.state.formFields}
                            onCancel={() => this.onClose()}
                            onChange={this.onChange}
                            onSubmit={(data) => {
                                this.onSave(DataGridUtility.getRowData(data, this.columns));
                            }}
                        />
                        {this.props.tableName != TABLES.DEAL && !this.props.isCustomForm &&
                            <div className="row row-reverse mt-l">
                                <DKButton
                                    className="bg-gray1 border-m"
                                    title={"New Field"}
                                    icon={DKIcons.ic_add}
                                    // onClick={this.onCustomFieldAdd}
                                />
                            </div>
                        }
                    </>
                )}
                {this.state.formFields.length === 0 && (
                    <div
                        className="row justify-content-center"
                        style={{ minHeight: 100 }}
                    >
                        <DKSpinner title="Loading form fields..." />
                    </div>
                )}
            </Popup>
        );
    }
        
}

export const showPaySchedulePopup = (
    config: { tableName: string; displayName: string; defaultValues?: any; recordId?: string; isCustomForm?: any; inputData?: any },
    onSave: () => void,
    onClose: () => void
) => {
    const id = `add-new-rec-popup-${new Date().getTime()}`;
    let div = document.createElement("div");
    div.className = "app-font";
    div.setAttribute("id", id);
    ReactDOM.render(
        <AddEditPaySchedule
            id={id}
            tableName={config.tableName}
            onSave={onSave}
            onClose={onClose}
            defaultValues={config.defaultValues}
            recordId={config.recordId}
            displayName={config.displayName}
            isCustomForm={config.isCustomForm}
            inputData={config.inputData}
        />,
        document.body.appendChild(div)
    );
};

export default AddEditPaySchedule
